/**
 * 自定义Icon图标
 */

import Icon from '@ant-design/icons';

// 新元
export const XinYuanIcon = (props) => <Icon component={xinYuanSVG} {...props} />;
const xinYuanSVG = () => (
    <svg viewBox="-0.5 -0.5 597 592" width="1em" height="1em" fill="currentColor">
        <path d="M 245.5,-0.5 C 256.833,-0.5 268.167,-0.5 279.5,-0.5C 279.586,0.495904 279.252,1.32924 278.5,2C 252.628,18.1003 227.628,35.4337 203.5,54C 152.892,104.608 102.392,155.108 52,205.5C 33.9306,226.933 30.5972,250.6 42,276.5C 45.4224,281.678 49.089,286.678 53,291.5C 115.086,352.918 177.253,414.418 239.5,476C 247.494,480.872 255.161,480.538 262.5,475C 316.167,421.333 369.833,367.667 423.5,314C 424.635,313.251 425.635,313.417 426.5,314.5C 433.652,322.152 440.985,329.652 448.5,337C 394.473,391.027 340.473,445.027 286.5,499C 262.93,520.601 238.93,520.934 214.5,500C 151.973,438.139 89.4731,376.306 27,314.5C 10.9496,296.836 1.78295,276.169 -0.5,252.5C -0.5,249.167 -0.5,245.833 -0.5,242.5C 1.8645,220.765 10.0312,201.431 24,184.5C 76.3377,132.162 128.838,79.6623 181.5,27C 199.731,10.5367 221.064,1.37005 245.5,-0.5 Z" />
        <path d="M 334.5,-0.5 C 342.833,-0.5 351.167,-0.5 359.5,-0.5C 379.148,2.15635 396.481,9.98969 411.5,23C 463.567,75.4037 515.4,126.904 567,177.5C 583.263,195.128 593.096,215.795 596.5,239.5C 596.5,251.5 596.5,263.5 596.5,275.5C 579.198,250.947 561.364,226.613 543,202.5C 493.662,153.162 444.162,103.662 394.5,54C 372.648,32.9229 347.648,28.2562 319.5,40C 312.216,44.9497 305.216,50.2831 298.5,56C 238.027,115.806 177.527,175.639 117,235.5C 110.704,243.843 111.037,251.843 118,259.5C 171.87,313.035 226.037,366.868 280.5,421C 273.167,428.333 265.833,435.667 258.5,443C 257.5,443.667 256.5,443.667 255.5,443C 200.441,388.609 145.274,334.109 90,279.5C 78.3471,266.553 74.6804,251.553 79,234.5C 82.1446,227.544 85.8112,220.877 90,214.5C 155.141,149.693 220.641,85.1927 286.5,21C 300.534,9.27352 316.534,2.10685 334.5,-0.5 Z" />
        <path d="M 596.5,329.5 C 596.5,338.833 596.5,348.167 596.5,357.5C 592.306,378.553 582.806,396.886 568,412.5C 517.499,463.334 466.666,513.834 415.5,564C 397.564,579.471 376.898,588.637 353.5,591.5C 341.833,591.5 330.167,591.5 318.5,591.5C 318.414,590.504 318.748,589.671 319.5,589C 346.552,572.142 372.552,553.809 397.5,534C 445.802,485.364 494.302,437.197 543,389.5C 560.622,369.674 565.622,347.007 558,321.5C 553.24,311.64 547.24,302.64 540,294.5C 480.529,237.029 421.695,178.862 363.5,120C 355.62,112.246 346.62,110.579 336.5,115C 282,169.5 227.5,224 173,278.5C 165.387,270.887 157.721,263.221 150,255.5C 149.333,254.833 149.333,254.167 150,253.5C 203.527,199.973 257.027,146.473 310.5,93C 316.552,87.9474 322.885,83.2807 329.5,79C 346.909,73.2305 362.909,75.8972 377.5,87C 442.469,151.264 507.302,215.097 572,278.5C 584.487,293.472 592.654,310.472 596.5,329.5 Z" />
        <path d="M 263.5,591.5 C 254.833,591.5 246.167,591.5 237.5,591.5C 218.388,588.947 201.388,581.447 186.5,569C 132.243,515.745 78.0765,461.911 24,407.5C 3.35273,380.241 -4.14727,349.574 1.5,315.5C 19.1092,342.384 37.9426,368.384 58,393.5C 104.898,441.396 152.732,488.896 201.5,536C 223.773,557.997 249.439,562.997 278.5,551C 285.115,546.719 291.448,542.053 297.5,537C 357.866,477.303 418.366,417.469 479,357.5C 484.898,345.83 483.064,335.496 473.5,326.5C 421.406,275.239 369.573,223.905 318,172.5C 317.333,171.5 317.333,170.5 318,169.5C 325.348,161.985 332.848,154.652 340.5,147.5C 396.099,202.265 451.599,257.265 507,312.5C 522.007,331.279 523.341,350.946 511,371.5C 506.711,377.458 502.044,383.124 497,388.5C 438.022,445.808 379.189,503.641 320.5,562C 304.436,577.697 285.436,587.531 263.5,591.5 Z" />
    </svg>
);

// 工作流
export const WorkFlowIcon = (props) => <Icon component={workFlowSVG} {...props} />;
const workFlowSVG = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" >
        <circle cx="5" cy="18" r="2.5" fill="currentColor" />
        <circle cx="19" cy="18" r="2.5" fill="currentColor" />
        <circle cx="12" cy="8" r="2.5" fill="currentColor" />
        <path d="M5 15.5c0-5 7-8 7-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
        <path d="M19 15.5c0-5-7-8-7-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" fill="none" />
    </svg>
);

// 智能体
export const AgentIcon = (props) => <Icon component={agentSVG} {...props} />;
const agentSVG = () => (
    <svg width="18px" height="18px" viewBox="0 0 24 24" fill="currentColor">
        <circle cx="12" cy="12" r="3" fill="currentColor" />
        <path d="M12 5V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12 16V19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M5 12H8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M16 12H19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <circle cx="12" cy="4" r="1.5" fill="currentColor" />
        <circle cx="12" cy="20" r="1.5" fill="currentColor" />
        <circle cx="4" cy="12" r="1.5" fill="currentColor" />
        <circle cx="20" cy="12" r="1.5" fill="currentColor" />
    </svg>
);

// 大模型
export const LLMIcon = (props) => <Icon component={llmSVG} {...props} />;
LLMIcon.displayName = 'LLMIcon';
const llmSVG = () => (
    <svg width="2em" height="2em" viewBox="0 0 1024 1024" fill="none">
        <path d="M256 384L512 256L768 384L512 512L256 384Z" stroke="currentColor" strokeWidth="40" strokeLinejoin="round" />
        <path d="M256 384V640L512 768V512" stroke="currentColor" strokeWidth="40" strokeLinejoin="round" />
        <path d="M512 512L768 384V640L512 768" stroke="currentColor" strokeWidth="40" strokeLinejoin="round" />
        <circle cx="512" cy="384" r="30" />
        <circle cx="416" cy="448" r="20" />
        <circle cx="608" cy="448" r="20" />
        <circle cx="512" cy="576" r="20" />
        <path d="M512 384L416 448M512 384L608 448M416 448L512 576M608 448L512 576"
            stroke="currentColor" strokeWidth="20" strokeLinecap="round" />
    </svg>
);

// MCP
export const MCPIcon = (props) => <Icon component={mcpSVG} {...props} />;
MCPIcon.displayName = 'MCPIcon';
const mcpSVG = () => (
    <svg viewBox="0 0 24 24" width="2em" height="2em" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="2.5" />
        <line x1="12" y1="5" x2="12" y2="9.5" />
        <line x1="12" y1="14.5" x2="12" y2="19" />
        <line x1="5" y1="12" x2="9.5" y2="12" />
        <line x1="14.5" y1="12" x2="19" y2="12" />
    </svg>
);

// API
export const APIIcon = (props) => <Icon component={apiSVG} {...props} />;
APIIcon.displayName = 'APIIcon';
const apiSVG = () => (
    <svg width="2em" height="2em" viewBox="0 0 24 24" fill="none">
        <rect x="5" y="8" width="4" height="8" rx="1.2" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <rect x="14" y="8" width="4" height="8" rx="1.2" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
        <path d="M9 11H14M9 13H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);

// 开始
export const StartIcon = (props) => <Icon component={startSVG} {...props} />;
StartIcon.displayName = 'StartIcon';
const startSVG = () => (
    <svg width="2em" height="2em" viewBox="0 0 1024 1024" fill="none">
        <path d="M512 150L800 300V724L512 874L224 724V300L512 150Z" stroke="currentColor" strokeWidth="24" strokeLinejoin="round" />
        <path d="M362 362V662L662 512L362 362Z" fill="currentColor" />
    </svg>
);

// 停止
export const StopIcon = (props) => <Icon component={stopSVG} {...props} />;
StopIcon.displayName = 'StopIcon';
const stopSVG = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" fill="none" />
        <rect x="8" y="8" width="8" height="8" rx="1.5" fill="currentColor" />
    </svg>
)

// 结束
export const EndIcon = (props) => <Icon component={endSVG} {...props} />;
EndIcon.displayName = 'EndIcon';
const endSVG = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="2em" height="2em">
        <rect x="480" y="256" width="64" height="512" rx="8" fill="currentColor" />
        <path d="M544 288 L800 384 L544 480 Z" fill="currentColor" />
        <ellipse cx="512" cy="800" rx="160" ry="40" fill="currentColor" opacity="0.3" />
    </svg>
);

// 文本
export const TextIcon = (props) => <Icon component={textSVG} {...props} />;
TextIcon.displayName = 'TextIcon';
const textSVG = () => (
    <svg width="1em" height="1em" viewBox="0 0 200 200" fill="currentColor">
        <path d="M40 50H160V65H110V185H90V65H40V50Z" fill="currentColor" />
    </svg>
);

// ID
export const IDIcon = (props) => <Icon component={idSVG} {...props} />;
IDIcon.displayName = 'IDIcon';
const idSVG = () => (
    <svg width="1.1em" height="1.1em" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" fill="none" />
        <text x="9" y="16" fontFamily="Arial, sans-serif" fontWeight="bold" fill="currentColor" textAnchor="middle">I</text>
        <text x="15" y="16" fontFamily="Arial, sans-serif" fontWeight="bold" fill="currentColor" textAnchor="middle">D</text>
    </svg>
);

// 缩放自适应
export const ZoomFitIcon = (props) => <Icon component={zoomFitSVG} {...props} />;
const zoomFitSVG = () => (
    <svg width="1.1em" height="1.1em" viewBox="0 0 1024 1024" fill="none">
        <path d="M256 128H128V256" stroke="currentColor" strokeWidth="64" strokeLinecap="round" />
        <path d="M256 896H128V768" stroke="currentColor" strokeWidth="64" strokeLinecap="round" />
        <path d="M768 128H896V256" stroke="currentColor" strokeWidth="64" strokeLinecap="round" />
        <path d="M768 896H896V768" stroke="currentColor" strokeWidth="64" strokeLinecap="round" />
        <rect x="256" y="256" width="512" height="512" rx="64" stroke="currentColor" strokeWidth="64" />
        <path d="M384 448H640V576H384V448Z" fill="currentColor" />
    </svg>
);

// 内容创作
export const ContentCreationIcon = (props) => <Icon component={ontentCreationSVG} {...props} />;
const ontentCreationSVG = () => (
    <svg width="1.1em" height="1.1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M13 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V9L13 2Z" />
        <polyline points="13,2 13,9 20,9" />
        <line x1="8" y1="14" x2="16" y2="14" />
        <line x1="8" y1="18" x2="12" y2="18" />
        <path d="M16 2L17 4L19 5L17 6L16 8L15 6L13 5L15 4L16 2Z" fill="currentColor" stroke="none" />
    </svg>
);

// 用户
export const UserIcon = (props) => <Icon component={UserSVG} {...props} />;
const UserSVG = () => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2.5 13.5V12a3 3 0 0 1 3-3h5a3 3 0 0 1 3 3v1.5" />
        <circle cx="8" cy="4" r="2.5" />
    </svg>
);

// 日志
export const LogIcon = (props) => <Icon component={LogSVG} {...props} />;
const LogSVG = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" width="1em" height="1em" fill="currentColor">
        <rect x="128" y="128" width="768" height="768" rx="128" fill="none" stroke="currentColor" strokeWidth="64" />
        <path d="M256 320h512M256 512h512M256 704h512" stroke="currentColor" strokeWidth="64" strokeLinecap="round" />
    </svg>
);

// 数量要求
export const QuantityRequirementIcon = (props) => <Icon component={QuantityRequirementSVG} {...props} />;
const QuantityRequirementSVG = () => (
    <svg viewBox="0 0 1024 1024" version="1.1" width="1em" height="1em" fill="currentColor">
        <path d="M512 170.667c-212.074 0-384 68.63-384 153.333v384c0 84.703 171.926 153.333 384 153.333s384-68.63 384-153.333V324c0-84.703-171.926-153.333-384-153.333z m320 153.333c0 47.148-125.963 106.667-320 106.667S192 371.148 192 324s125.963-106.667 320-106.667 320 59.519 320 106.667z m-320 469.333c-194.037 0-320-59.519-320-106.667v-128c42.37 37.629 173.037 74.667 320 74.667s277.63-37.038 320-74.667v128c0 47.148-125.963 106.667-320 106.667z m0-213.333c-194.037 0-320-59.519-320-106.667v-128c42.37 37.629 173.037 74.667 320 74.667s277.63-37.038 320-74.667v128c0 47.148-125.963 106.667-320 106.667z" />
    </svg>
);

// 混合查询
export const HybridQueryIcon = (props) => <Icon component={HybridQuerySVG} {...props} />;
const HybridQuerySVG = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" strokeWidth="2" />
        <path d="M21 21L17 17" strokeWidth="2" strokeLinecap="round" />
        <path d="M8 11H14" strokeWidth="2" strokeLinecap="round" />
        <path d="M11 8L11 14" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

// 组织
export const OrganizationIcon = (props) => <Icon component={OrganizationSVG} {...props} />;
const OrganizationSVG = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M3 5h6v6H3V5zM15 5h6v6h-6V5zM3 13h6v6H3v-6zM15 13h6v6h-6v-6z" />
        <path d="M9 8h6M9 16h6M8 9v6M16 9v6" strokeLinecap="round" />
    </svg>
);

// 指令
export const CommandIcon = (props) => <Icon component={CommandSvg} {...props} />;
const CommandSvg = () => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <path d="M1018.645 531.298c8.635-18.61 4.601-41.42-11.442-55.864l-205.108-184.68c-19.7-17.739-50.05-16.148-67.789 3.552-17.738 19.7-16.148 50.051 3.553 67.79l166.28 149.718-167.28 150.62c-19.7 17.738-21.291 48.088-3.553 67.789 17.739 19.7 48.089 21.291 67.79 3.553l205.107-184.68a47.805 47.805 0 0 0 12.442-17.798zM119.947 511.39l166.28-149.719c19.7-17.738 21.29-48.088 3.552-67.789-17.738-19.7-48.088-21.291-67.789-3.553L16.882 475.01C.84 489.456-3.194 512.264 5.44 530.874a47.805 47.805 0 0 0 12.442 17.798l205.108 184.68c19.7 17.739 50.05 16.148 67.79-3.552 17.738-19.7 16.147-50.051-3.553-67.79l-167.28-150.62zm529.545-377.146c24.911 9.066 37.755 36.61 28.688 61.522L436.03 861.068c-9.067 24.911-36.611 37.755-61.522 28.688-24.911-9.066-37.755-36.61-28.688-61.522l242.15-665.302c9.067-24.911 36.611-37.755 61.522-28.688z" />
    </svg>
);

// 配额
/**
 * 实线容器：表示总配额容量
 * 虚线对角线：象征动态消耗过程
 * 完整容器 → 可用总配额
 * 对角线方向 → 时间/消耗流向
 * 虚线形态 → 持续消耗过程
*/
export const QuotaIcon = (props) => <Icon component={QuotaSvg} {...props} />;
const QuotaSvg = () => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none">
        <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.5" />
        <path d="M4 20L20 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 4" />
    </svg>
)

// 工单
export const WOIcon = (props) => <Icon component={WOSvg} {...props} />;
const WOSvg = () => (
    <svg width="1em" height="1em" viewBox="0 0 1024 1024" fill="none">
        <path d="M725.333 170.667H213.333a42.667 42.667 0 0 0-42.666 42.666v597.334A42.667 42.667 0 0 0 213.333 853.3h597.334a42.667 42.667 0 0 0 42.666-42.666V298.667L725.333 170.667z" stroke="currentColor" strokeWidth="80" strokeLinejoin="round" />
        <path d="M640 170.667v128h128M298.667 426.667h426.666M298.667 597.333h426.666M298.667 768h256" stroke="currentColor" strokeWidth="80" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// 供应商
export const SupplierIcon = (props) => <Icon component={SupplierSvg} {...props} />;
const SupplierSvg = () => (
    <svg width="1em" height="1em" viewBox="0 0 1024 1024" fill="none" stroke="currentColor" strokeWidth="80" strokeLinecap="round" strokeLinejoin="round" >
        <path d="M128 896V576L512 192l384 384v320" />
        <path d="M128 576L512 192l384 384M320 896h384M320 576h384" />
    </svg>
)

// 路口
export const IntersectionIcon = (props) => <Icon component={IntersectionSvg} {...props} />;
const IntersectionSvg = () => (
    <svg width="1em" height="1em" viewBox="0 0 1 1" fill="none" stroke="currentColor" strokeWidth="0.07">
        <rect x="0.035" y="0.035" width="0.93" height="0.93" rx="0.1" />
        <path d="M0.2 0.5H0.8M0.5 0.2V0.8" strokeLinecap="round" />
        <path d="M0.35 0.35L0.35 0.65M0.65 0.35L0.65 0.65" strokeLinecap="square" />
    </svg>
);